import validate from "/app/node_modules/.pnpm/nuxt@4.5.2_b39e155b9d5ab875bcce11a20b66e7bf/node_modules/nuxt/dist/pages/runtime/validate.js";
import legacy_45redirect_45global from "/app/apps/liquidity.forgd.com/middleware/legacy-redirect.global.ts";
import manifest_45route_45rule from "/app/node_modules/.pnpm/nuxt@4.5.2_b39e155b9d5ab875bcce11a20b66e7bf/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  legacy_45redirect_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/app/libs/nuxt-forgd-layer-core/layers/auth/middleware/auth.ts"),
  guest: () => import("/app/libs/nuxt-forgd-layer-core/layers/auth/middleware/guest.ts"),
  "rfq-access": () => import("/app/apps/liquidity.forgd.com/layers/rfq/middleware/rfq-access.ts"),
  "rfq-tab-guard": () => import("/app/apps/liquidity.forgd.com/layers/rfq/middleware/rfq-tab-guard.ts")
}